import React from 'react';
import BadgeBase from './BadgeBase';
import TEBadgeSignal from '../../types/TEBadgeSignal';

const Info = (props) => <BadgeBase {...props} signal={TEBadgeSignal.Info} />;

export default Info;
